export const getDefaultState = () => {
    return {
        typologies: [],
        typology: {
            id: null,
            name: null,
            description: null,
            code: null,
        },
        validation_typology: {
            name: null,
            description: null,
            code: null,
        },
        search: {
            name: null,
            description: null,
        },
    }
}
export default getDefaultState()
